import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionTitle, Loading, StatCard } from "@/components/common";
import { Target, TrendingUp } from "lucide-react";

export default function Performance() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/performance").then(({ data }) => setD(data)); }, []);
  if (!d) return <Loading label="Loading performance" />;

  const t = d.targets.six_figure_standard;
  const e = d.targets.elite_production;
  const bonus = d.production_bonus;

  return (
    <div className="max-w-6xl">
      <SectionTitle sub="Progress tracking — not a guarantee of employee earnings">Performance</SectionTitle>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Today Collected" value={`$${d.today_collected.toLocaleString()}`} accent icon={TrendingUp} testid="perf-today" />
        <StatCard label="Daily Target" value={`$${t.daily.toLocaleString()}`} icon={Target} testid="perf-daily" />
        <StatCard label="Weekly Target" value={`$${t.weekly.toLocaleString()}`} testid="perf-weekly" />
        <StatCard label="Annual Benchmark" value={`$${(t.annual / 1000)}k`} sub={`${t.days} days / ${t.weeks} weeks`} testid="perf-annual" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="sg-card p-5" data-testid="elite-card">
          <div className="font-head text-xl font-bold mb-3">Elite Production</div>
          <div className="grid grid-cols-3 gap-3">
            <div><div className="text-xs" style={{ color: "var(--txt2)" }}>Daily</div><div className="font-head text-2xl font-extrabold">${e.daily.toLocaleString()}</div></div>
            <div><div className="text-xs" style={{ color: "var(--txt2)" }}>Weekly</div><div className="font-head text-2xl font-extrabold">${e.weekly.toLocaleString()}</div></div>
            <div><div className="text-xs" style={{ color: "var(--txt2)" }}>Annual</div><div className="font-head text-2xl font-extrabold">${(e.annual / 1000)}k</div></div>
          </div>
        </div>

        <div className="sg-card p-5" data-testid="bonus-card">
          <div className="font-head text-xl font-bold mb-3">Production Bonus (per employee, marginal)</div>
          {bonus.note ? (
            <div className="text-sm" style={{ color: "var(--txt2)" }}>{bonus.note}</div>
          ) : (
            <>
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm" style={{ color: "var(--txt2)" }}>Eligible revenue: ${bonus.eligible_revenue.toLocaleString()}</span>
                <span className="font-head text-2xl font-extrabold" style={{ color: "var(--accent)" }} data-testid="bonus-value">${bonus.bonus_per_employee.toLocaleString()}</span>
              </div>
              <div className="flex flex-col gap-1">
                {bonus.breakdown.map((b, i) => (
                  <div key={i} className="flex items-center justify-between text-xs font-mono">
                    <span style={{ color: "var(--txt2)" }}>{b.band} @ {Math.round(b.rate * 100)}%</span>
                    <span>${b.portion.toLocaleString()} → ${b.amount.toLocaleString()}</span>
                  </div>
                ))}
              </div>
              <div className="text-xs mt-3" style={{ color: "var(--muted)" }}>
                Production tracking only. Payroll, overtime & taxes are processed through approved payroll/accounting systems.
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
